import React from "react";
import { Link, NavLink } from "react-router-dom";
import {
  Row,
  Card,
  Col,
  Container,
  Badge,
  Form,
  InputGroup,
  Button,
  Tab,
  Nav,
  ButtonToolbar,
  ToggleButton,
  ToggleButtonGroup,
  Image,
  OverlayTrigger,
  Tooltip,
  Table,
} from "react-bootstrap";
import ItemsCarousel from "./common/ItemsCarousel";
import ChooseAddressCard from "./common/ChooseAddressCard";
import CheckoutItem from "./common/CheckoutItem";
import MutilUpload from "./common/MultipleImageUploadComponent";
import AddAddressModal from "./modals/AddAddressModal";
import FontAwesome from "./common/FontAwesome";
import Icofont from "react-icofont";
import { Multiselect } from "multiselect-react-dropdown";
import DataService from "../services/DataService";
import { alertCreation, alertError } from "../components/Alerts";
import SimpleReactValidator from "simple-react-validator";

const KeyCodes = {
  comma: 188,
  enter: 13,
};

const delimiters = [KeyCodes.comma, KeyCodes.enter];
class TopUpItems extends React.Component {
  constructor(props, context) {
    super(props, context);

    this.validator = new SimpleReactValidator({ autoForceUpdate: this });

    this.state = {
      showAddressModal: false,
      createForm: {},
      addedItemscreateForm: {},
      showHideDelivery: false,
      tags: [],
      options: [],
    };
  }

  getFoodName(val) {
    console.log(val);
    let foodObj = this.props.optionsFood.find((f) => f.id == val);
    let name = typeof foodObj != "undefined" ? foodObj.name : "unknown";
    return name;
  }
  getPaymentType(val) {
    console.log(val, this.props.payOptions);

    let payObj = this.props.payOptions.find((p) => p.id === val);
    let name = typeof payObj != "undefined" ? payObj.name : "unknown";
    return name;
  }

  createAddedItemsFormHandler = (event) => {
    let key = "";
    let value = "";
    let inputForm = { ...this.state.addedItemscreateForm };
    if (event.target.type == "text" || event.target.type == "textarea") {
      key = event.target.name;
      value = event.target.value;
    } else if (event.target.type == "select-one") {
      key = event.target.name;
      value = event.target.value;
    }

    inputForm[key] = value;
    this.setState({ addedItemscreateForm: inputForm });
  };
  createFormHandler = (event) => {
    let key = "";
    let value = "";
    let inputForm = { ...this.state.createForm };

    if (event.target.type == "text" || event.target.type == "textarea") {
      key = event.target.name;
      value = event.target.value;
    } else if (event.target.type == "select-one") {
      key = event.target.name;
      value = event.target.value;
    }

    inputForm[key] = value;
    console.log(inputForm);
    this.setState({ createForm: inputForm });
  };

  hideAddressModal = () => this.setState({ showAddressModal: false });

  hideDelivery(name) {
    this.setState({ showHideDelivery: !this.state.showHideDelivery });
  }

  getQty = ({ id, quantity }) => {
    //console.log(id);
    //console.log(quantity);
  };
isTabFormValid()
{
	

	return ((this.validator.fieldValid('tab_title'))&&(this.validator.fieldValid('tab_type')))
}
isFoodItemFormValid()
{
	
	
	
   
	return ((this.validator.fieldValid('payment_type'))&&(this.validator.fieldValid('food_type')))
}
  fieldValid
  render() {
    const { tags } = this.state;
    return (
      <div>
        <div className="pt-2"></div>

        <span className="hidden">
          {/*this.props.shouldHide ? 'hidden' : ''*/}

          <div className="pt-2"></div>

          <div className="pt-2"></div>
          <div className="bg-white rounded shadow-sm p-4 osahan-payment">
            <span></span>
            <Card>
              <Card.Body>
                <h6 className="mb-1">Add Topup Items</h6>
                <Form.Group className="col-md-12">
                  <Form.Label>Tab Title</Form.Label>
                  {this.validator.message(
                    "tab_title",
                    this.state.createForm["tab_title"],
                    "required|min:2|max:10"
                  )}

                  <InputGroup>
                    <Form.Control
                      type="text"
                      onChange={this.createFormHandler}
                      name="tab_title"
                      placeholder="Enter Tab Title"
                    />
                  </InputGroup>
                </Form.Group>
                <Form.Group className="col-md-4">
                  <Form.Label>Selection Type</Form.Label>
                  {this.validator.message(
                    "tab_type",
                    this.state.createForm["tab_type"],
                    "required"
                  )}

                  <Form.Control
                    as="select"
                    onChange={this.createFormHandler}
                    name="tab_type"
                  >
                    <option value="1">Madatory</option>
                    <option value="2">Optional</option>
                  </Form.Control>
                </Form.Group>
                <Nav>
                  <Nav.Link
                    eventKey={0}
                    as={NavLink}
                    activeclassname="active"
                    className="pt-3"
                    to="#"
                    onClick={() => {
                      if (this.isTabFormValid() == true) {
                        this.props.addNewTab(this.state.createForm);
                      } else {
                        this.validator.showMessages();
                      }
                    }}
                  >
                    Add New tab
                    <Icofont icon="plus-circle" />
                    <span className="sr-only">(current)</span>
                  </Nav.Link>
                </Nav>
              </Card.Body>
            </Card>

            <Tab.Container id="left-tabs-example" defaultActiveKey="first">
              <Row>
                <Col sm={4} className="pr-0">
                  <Nav variant="pills" className="flex-column">
                    {this.props.upsellItems.map((upsellObj) => {
                      console.log(upsellObj);
                      let tabId = "item" + upsellObj.id;
                      console.log(tabId);
                      return (
                        <Nav.Link eventKey={tabId}>
                          <Icofont icon="food-basket" /> {upsellObj.title}
                        </Nav.Link>
                      );
                    })}
                  </Nav>
                </Col>
                <Col sm={8} className="pl-0">
                  <Tab.Content className="h-100">
                    {this.props.upsellItems.map((upsellObj) => {
                      let tabId = "item" + upsellObj.id;
                      return (
                        <Tab.Pane eventKey={tabId}>
                          <h6 className="mb-3 mt-0 mb-3">Add new </h6>

                          <Form>
                            <div className="form-row">
                              <Form.Group className="col-md-8">
                                <Form.Label>Food Item</Form.Label>
                                {this.validator.message(
                                  "food_type",
                                  this.state.addedItemscreateForm["food_type"],
                                  "required"
                                )}

                                <Form.Control
                                  as="select"
                                  name="food_type"
                                  onChange={this.createAddedItemsFormHandler}
                                >
                                  {this.props.optionsFood.map((foodObj) => {
                                    return (
                                      <option value={foodObj.id}>
                                        {foodObj.name}
                                      </option>
                                    );
                                  })}
                                </Form.Control>
                              </Form.Group>
                              <Form.Group className="col-md-8">
                                <Form.Label>Pay Type</Form.Label>
								{this.validator.message(
                                  "payment_type",
                                  this.state.addedItemscreateForm["payment_type"],
                                  "required"
                                )}
                                <Form.Control
                                  as="select"
                                  name="payment_type"
                                  onChange={this.createAddedItemsFormHandler}
                                >
                                  <option value="1">Free</option>
                                  <option value="2">Paid</option>
                                </Form.Control>
                              </Form.Group>

                              <Form.Group className="col-md-12 mb-0">
                                <Link
                             
									onClick={() => {

										if (this.isFoodItemFormValid() == true) {
				


											this.props.addNewFoodItem(
												upsellObj.id,
												this.state.addedItemscreateForm
											  );									}else{
										this.validator.showMessages();
				
									}
								
								
								}}

                                  
                                  className="btn btn-success btn-block btn-lg"
                                >
                                  ADD
                                  <Icofont icon="long-arrow-right" />
                                </Link>
                              </Form.Group>
                            </div>
                          </Form>
                          <hr></hr>
                          <Table striped bordered hover>
                            <thead>
                              <tr>
                                <th>#</th>
                                <th> Name</th>
                                <th>Pay Type</th>

                                <th></th>
                              </tr>
                            </thead>
                            <tbody>
                              {typeof (upsellObj.added_items != "undefined") &&
                                upsellObj.added_items.length > 0 &&
                                upsellObj.added_items.map((itemObj) => {
                                  console.log(itemObj);
                                  return (
                                    <tr>
                                      <td>{itemObj.id}</td>
                                     
                                      <td>
                                        {this.getFoodName(itemObj.food_type)}
                                      </td>
									  <td>
                                        {this.getPaymentType(
                                          itemObj.payment_type
                                        )}
                                      </td>
                                      <td>
                                        <Link
                                          className="btn btn-success btn-block btn-sm"
                                          onClick={() => {
                                            this.props.removeFoodItem(
                                              upsellObj.id,
                                              itemObj
                                            );
                                          }}
                                        >
                                          <Icofont icon="trash" />
                                        </Link>
                                      </td>
                                    </tr>
                                  );
                                })}
                            </tbody>
                          </Table>
                          <card>
                            {" "}
                            <span
                              onClick={() => {
                                this.props.removeTab(upsellObj);
                              }}
                            >
                              <Icofont icon="trash" />
                            </span>
                          </card>
                        </Tab.Pane>
                      );
                    })}
                  </Tab.Content>
                </Col>
              </Row>
            </Tab.Container>
          </div>
        </span>
      </div>
    );
  }
}

export default TopUpItems;
